
export const convertOldDesignJsonToNewDesignJson = (design: any) => {
    layoutPropertyToFillProperty(design.properties);
    rotationPropertyToRotateProperty(design.properties);
    gridFillModeToPatternFillMode(design.properties);
    randomizeObjectToNumber(design.properties);
};

const randomizeObjectToNumber = (o: any) => {

    if ((typeof o["scale"]["randomize"]) === "object") {
        o["scale"]["randomize"] = Math.abs(
            o["scale"]["randomize"]["min"] - o["scale"]["randomize"]["max"]) / 2;
    }

    if ((typeof o["rotate"]["randomize"]) === "object") {
        o["rotate"]["randomize"] = Math.abs(
            o["rotate"]["randomize"]["min"] - o["rotate"]["randomize"]["max"]) / 360;
    }
};

const rotationPropertyToRotateProperty = (o: any) => {

    if (o["rotation"] !== undefined) {

        o["rotate"] = o["rotation"];
        delete o["rotation"];
    }
};

const gridFillModeToPatternFillMode = (o: any) => {

    if (o["fill"]["mode"] === "grid") {
        o["fill"]["mode"] = "pattern";
        o["fill"]["options"]["pattern"] = o["fill"]["options"]["points"];
        delete o["fill"]["options"]["points"];
    }
};

const layoutPropertyToFillProperty = (o: any) => {

    if (o["layout"] !== undefined) {

        o["fill"] = {
            mode: "pattern",
            randomize: 0,
            options: {
                ...o["layout"],
                pattern: o["layout"]["points"]
            }
        };

        delete o["layout"];
    }
};